// extracted by mini-css-extract-plugin
export default {"imageContainer":"M1-z","summaryPar":"N1-z","ratingCategories":"O1-z","reviewerInfo":"P1-z","reviewTypes":"Q1-z","expanded":"R1-z"};